// Helpers for linking out to the LiteAPI whitelabel booking site.
// The whitelabel base URL is configured via REACT_APP_LITEAPI_WHITELABEL_URL.

const WHITELABEL_BASE_URL =
  process.env.REACT_APP_LITEAPI_WHITELABEL_URL || "https://standbytraveller.nuitee.link";

interface WhitelabelOptions {
  /** ISO currency code shown on the booking site, e.g. "EUR", "USD". */
  currency?: string;
  /** UI language, e.g. "en", "fr", "de". */
  language?: string;
  /** Optional path/deeplink on the whitelabel site (e.g. "/hotels"). Defaults to home. */
  path?: string;
}

/**
 * Builds a deeplink to the LiteAPI whitelabel booking site with global params
 * (currency / language) applied. The user completes search & booking on the
 * whitelabel domain.
 */
export const getWhitelabelUrl = ({
  currency = "EUR",
  language = "en",
  path = "/",
}: WhitelabelOptions = {}): string => {
  const url = new URL(path, WHITELABEL_BASE_URL);
  url.searchParams.set("currency", currency);
  url.searchParams.set("language", language);
  return url.toString();
};

/** Opens the whitelabel booking site in a new tab. */
export const openWhitelabel = (options?: WhitelabelOptions): void => {
  window.open(getWhitelabelUrl(options), "_blank", "noopener,noreferrer");
};
